const url = "http://localhost:8000/public/uploads/book_cover/";
export default url;
